"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jumpSteps = void 0;
var getWizardStrategy_1 = require("./dependencies/getWizardStrategy");
var jumpSteps = function (setHistory, options) { return function (jumpSize) {
    var wizardStrategy = getWizardStrategy_1.getWizardStrategy(options);
    if (wizardStrategy === "simple") {
        throw new Error("Wizard: steps jumping does not currently work with strings");
    }
    return setHistory(function (ps) { return __spreadArrays(ps, [ps[ps.length - 1] + jumpSize]); });
}; };
exports.jumpSteps = jumpSteps;
//# sourceMappingURL=jumpSteps.js.map